export default __webpack_public_path__ + "static/media/partnershipNetworkImg.cbc8705f.png";